import { useLang } from "../../i18n/LanguageContext";
import Stats from "./Stats";

export default function About() {
  const { t } = useLang();

  return (
    <section id="about" className="py-32 bg-[#141416] border-t border-b border-white/5 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-16 items-center">

          <div className="lg:col-span-7 space-y-8">
            <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.about.label}</div>
            <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase leading-tight">
              {t.about.title1} <br />{t.about.title2}
            </h2>
            <p className="text-zinc-400 leading-relaxed font-light text-base sm:text-lg">{t.about.body}</p>

            <div className="grid sm:grid-cols-2 gap-6 pt-2">
              <div className="p-6 rounded bg-gradient-to-br from-white/5 to-transparent border border-white/5 space-y-2">
                <h3 className="text-xs font-black text-[#F28C18] uppercase tracking-wider flex items-center gap-2">
                  <i className="fas fa-eye" /> {t.about.vision}
                </h3>
                <p className="text-xs text-zinc-400 leading-relaxed">{t.about.visionText}</p>
              </div>
              <div className="p-6 rounded bg-gradient-to-br from-white/5 to-transparent border border-white/5 space-y-2">
                <h3 className="text-xs font-black text-[#F28C18] uppercase tracking-wider flex items-center gap-2">
                  <i className="fas fa-crosshairs" /> {t.about.mission}
                </h3>
                <p className="text-xs text-zinc-400 leading-relaxed">{t.about.missionText}</p>
              </div>
            </div>
          </div>

          <Stats />
        </div>
      </div>
    </section>
  );
}
